import SearchParamsBase from "../../../Elements/SearchParamsBase";
import InputTypesEnum from "../../../Enums/InputTypesEnum";

export default class ApolloCustomTriggerSearchParams extends SearchParamsBase
{
	initialize()
	{
		this.Id="";
		this.SurveyId="";
		this.IsActive="true"
	}

	//-------------------------------------------
	//-------- Fields for Search Panel ----------
	//-------------------------------------------

	static fieldsInSearchBox=[
		{fieldName:"Id",label:"Id", className:"col-4", type: InputTypesEnum.Number},
		{fieldName:"SurveyId",label:"SurveyId", className:"col-4", type: InputTypesEnum.Number},
		{fieldName:"IsActive",label:"Is Active", className:"col-4", type: InputTypesEnum.EmptyYesNoSelect},
	];

	static iconName="fa-solid fa-search";
	static saveType = "ApolloCustomTriggerSearchParams";

	//---------------------------
	
}